<template>
    <v-fade-transition mode="out-in">
    <v-layout align-center justify-center>
    <v-flex xs12 sm8 text-xs-center>
        <img class="responsive" src="img/4H_aloitus.png">
        <h2 class="display-1">Millainen metsänkäyttäjä olet?</h2>
        <p class="subheading">Mitä metsä merkitsee sinulle? Mitä teet mieluiten metsässä ollessasi?</p>
        <p class="subheading">Testaa millainen metsänkäyttäjä olet!</p>
        <v-btn @click.native="startQuiz" >Aloita testi</v-btn>
    </v-flex>
    </v-layout>
    </v-fade-transition>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'Intro',
  computed: {
  },
  methods: {
    startQuiz() {
      this.$store.dispatch('metsankayttaja/startQuiz', {router: this.$router})
    }
  },
  mounted() {
    this.$store.dispatch('metsankayttaja/fetchQuestions');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.responsive {
  width: 100%;
}
</style>
